import React from 'react';
import { Card, Badge, Container } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Sindhura from '../../../../Assets/Images/Sindhura.png';
import { faArrowRight } from '@fortawesome/free-solid-svg-icons';
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import Alphonso from '../../../../Assets/Images/Alphonso.png';
import Strawberry from '../../../../Assets/Images/Strawberry.png';
import BlackGrapes from '../../../../Assets/Images/BlackGrapes.png';
import Carousel from "react-multi-carousel";
import { title } from 'process';
import { ContainerType } from '../Models/Enum';
import { IMAGE_MAIN_ENDPOINT } from '../constant';

function PackagingTestimonials(props) {
 var data = props.items;
    return (
        <div className='row'>
            <div className='col'>
                <Card  className='imageTestimonials mx-auto'>

                   
                        <Card.Img className='rounded-5' variant="top"  src={IMAGE_MAIN_ENDPOINT+ (data.fileName != undefined && data.fileName != null && data.fileName)} style={{ textAlign: 'center' }} />
                   
                    {/* <div className='row text-white align-items-center justify-content-center' style={{backgroundColor: '#3a785d'}}>
                        <div className='col-auto pt-3 pb-3 '>
                            123
                        </div>
                        <div className='col pt-3 pb-3'>
                            Lorem ipsum dolor sit amet
                            consecteur dummy carbon
                        </div>
                    </div> */}
                 
                    

                </Card>
            </div>
        </div>

    );


}

export default PackagingTestimonials; 